"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApptSummary_1 = __importDefault(require("./ApptSummary"));
exports.default = ApptSummary_1.default;
//# sourceMappingURL=index.js.map